import { number, shape, string } from 'prop-types';

const currentConditionsType = shape({
  firstForecastTime: string,
  dew_point: shape({
    q: number,
    u: string,
  }),
  temperature: shape({
    q: number,
    u: string,
  }),
  weatherCondition: shape({
    data: string,
  }),
  wind_direction: shape({
    u: string,
    q: number,
  }),
  wind_speed: shape({
    u: string,
    q: number,
  }),
});

export default currentConditionsType;
